import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { MessageFormValues } from './project-response.hooks';

interface ImageChoiceSelection {
  messageId: string | null;
  value: string;
}

export function syncSelectionAtomToForm({
  selection,
  messageId,
  getValues,
  setValue,
}: {
  selection: ImageChoiceSelection;
  messageId: string | null;
  getValues: UseFormGetValues<MessageFormValues>;
  setValue: UseFormSetValue<MessageFormValues>;
}): void {
  if (!messageId || selection.messageId !== messageId) return;
  if (getValues('content') !== selection.value) {
    setValue('content', selection.value);
  }
}

export function syncFormContentToSelectionAtom({
  content,
  messageId,
  setSelection,
}: {
  content: string | undefined;
  messageId: string | null;
  setSelection: (
    updater: (prev: ImageChoiceSelection) => ImageChoiceSelection
  ) => void;
}): void {
  if (!messageId) return;
  const formValue = content ?? '';
  setSelection((prev) => {
    if (prev.messageId !== messageId) return prev;
    if (prev.value === formValue) return prev;
    return { messageId, value: formValue };
  });
}
